import { createWebHistory, createRouter } from 'vue-router'

import store from '@/store'

import Index from '@/components/Index'

import Login from '@/components/user/Login'

import ForgotPassword from '@/components/user/ForgotPassword'
import ChangePassword from '@/components/user/ChangePassword'

import Dashboard from '@/components/Dashboard'

import Methodology from '@/components/pdf_display/Methodology'
import ART from '@/components/pdf_display/ART'

import CompanyIndex from '@/components/company/Index'
import CompanyForm from '@/components/company/Form'
import CompanyFilter from '@/components/company/Filter'
import CompanyTable from '@/components/company/Table'

import MachineClassIndex from '@/components/machine_class/Index'
import MachineClassFilter from '@/components/machine_class/Filter'
import MachineClassForm from '@/components/machine_class/Form'
import MachineClassTable from '@/components/machine_class/Table'

import MachineIndex from '@/components/machine/Index'
import MachineFilter from '@/components/machine/Filter'
import MachineForm from '@/components/machine/Form'
import MachineMap from '@/components/machine/Map'
import MachineTable from '@/components/machine/Table'

import ConfinedSpaceIndex from '@/components/confined_space/Index'
import ConfinedSpaceFilter from '@/components/confined_space/Filter'
import ConfinedSpaceForm from '@/components/confined_space/Form'
import ConfinedSpaceMap from '@/components/confined_space/Map'
import ConfinedSpaceTable from '@/components/confined_space/Table'

import ConfinedSpacePreliminaryRiskAnalyses from '@/components/confined_space/preliminary_risk_analyses/Index'
import ConfinedSpaceRiskAnalyses from '@/components/confined_space/risk_analyses/Index'
import ConfinedSpaceRiskAnalysesForm from '@/components/confined_space/risk_analyses/Form'
import ConfinedSpaceRiskAnalysesMultiple from '@/components/confined_space/risk_analyses/Multiple'

import ConfinedSpaceActionPlanIndex from '@/components/confined_space/action_plan/Index'
import ConfinedSpaceActionPlanForm from '@/components/confined_space/action_plan/Form'


import WorkFrontIndex from '@/components/work_front/Index'
import WorkFrontFilter from '@/components/work_front/Filter'
import WorkFrontForm from '@/components/work_front/Form'
import WorkFrontTable from '@/components/work_front/Table'

import PreliminaryRiskAnalysisIndex from '@/components/preliminary_risk_analyses/Index'
import PrintRAindex from '@/components/preliminary_risk_analyses/print_ra/Index'
import RiskAnalysisPrintMachinesAndAr from '@/components/risk-analyses/Print'
import RiskAnalysisPrintMachines from '@/components/risk-analyses/components/MachinePrint'
import RiskAnalysisIndex from '@/components/risk-analyses/Index'

import NonComplianceModelIndex from '@/components/noncompliance_model/Index'
import NonComplianceModelFilter from '@/components/noncompliance_model/Filter'
import NonComplianceModelForm from '@/components/noncompliance_model/Form'
import NonComplianceModelTable from '@/components/noncompliance_model/Table'

import ActionPlanIndex from '@/components/action_plan/Index'
import ActionPlanForm from '@/components/action_plan/Form'
import ActionPlanPrintGraphics from '@/components/action_plan/print/Graphics'
import ActionPlanPrintSituations from '@/components/action_plan/print/Situations'
import ActionPlanFormItemDetailing from '@/components/action_plan/print/FormItemDetailing'
import SingnalingForm from '@/components/action_plan/adequacy_forms/SingnalingForm'
import BoilermakingForm from '@/components/action_plan/adequacy_forms/BoilermakingForm'
import ConstructionForm from '@/components/action_plan/adequacy_forms/ConstructionForm'
import SecurityDevicesForm from '@/components/action_plan/adequacy_forms/SecurityDevicesForm'
import ElectricForm from '@/components/action_plan/adequacy_forms/ElectricForm'
import PaintingForm from '@/components/action_plan/adequacy_forms/PaintingForm'
import DifficultiesForm from '@/components/action_plan/adequacy_forms/components/DifficultiesForm'

import UserIndex from '@/components/user/Index'
import UserFilter from '@/components/user/Filter'
import UserForm from '@/components/user/Form'
import RiskAnalysisChecklistForm from '@/components/risk-analyses/ChecklistForm'
import RiskAnalysisForm from '@/components/risk-analyses/Form'
import UserTable from '@/components/user/Table'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'index',
      components: {
        default: Index,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requiresAuth: false,
        controlPanel: null,
      },
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword,
      meta: {
        requiresAuth: false,
        controlPanel: null,
      }
    },
    {
      path: '/change-password/:id(\\d+)',
      name: 'change-password',
      component: ChangePassword,
      meta: {
        requiresAuth: false,
        controlPanel: null,
      },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      components: {
        default: Dashboard,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'admin',
      },
    },
    {
      path: '/companies/:action?',
      components: {
        default: CompanyIndex,
      },
      children: [
        {
          path: '',
          components: {
            filter: CompanyFilter,
            table: CompanyTable,
          },
        },
        {
          path: 'create',
          components: {
            filter: CompanyFilter,
            form: CompanyForm,
          },
        },
        {
          path: 'edit/:id(\\d+)',
          components: {
            filter: CompanyFilter,
            form: CompanyForm,
          },
        },
      ],
      meta: {
        requiresAuth: true,
        controlPanel: 'admin',
        admin: true,
      },
    },
    {
      path: '/machine-classes/:action?',
      components: {
        default: MachineClassIndex,
      },
      children: [
        {
          path: '',
          components: {
            filter: MachineClassFilter,
            table: MachineClassTable,
          },
        },
        {
          path: 'create',
          components: {
            filter: MachineClassFilter,
            form: MachineClassForm,
          },
        },
        {
          path: 'edit/:id(\\d+)',
          components: {
            filter: MachineClassFilter,
            form: MachineClassForm,
          },
        },
      ],
      meta: {
        requiresAuth: true,
        controlPanel: 'admin',
        admin: true,
      },
    },
    {
      path: '/machines/:action?',
      components: {
        default: MachineIndex,
      },
      children: [
        {
          path: '',
          components: {
            filter: MachineFilter,
            map: MachineMap,
            table: MachineTable,
          },
        },
        {
          path: 'create',
          components: {
            form: MachineForm,
          },
        },
        {
          path: 'edit/:id(\\d+)',
          components: {
            form: MachineForm,
          },
        },
      ],
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/confined-spaces/:action?',
      components: {
        default: ConfinedSpaceIndex,
      },
      children: [
        {
          path: '',
          name: 'confined-space',
          components: {
            filter: ConfinedSpaceFilter,
            map: ConfinedSpaceMap,
            table: ConfinedSpaceTable,
          },
        },
        {
          path: 'create',
          components: {
            form: ConfinedSpaceForm,
          },
        },
        {
          path: 'edit/:id(\\d+)',
          name: 'confined-space-edit',
          components: {
            form: ConfinedSpaceForm,
          },
        },
        {
          path: 'preliminary-risk-analyses',
          components: {
            preliminary_risk_analyses_index: ConfinedSpacePreliminaryRiskAnalyses,
          },
        },
        {
          path: 'risk-analyses-multiple',
          name: 'confined-spaces-risk-analyses-multiple',
          components: {
            risk_analyses_multiple: ConfinedSpaceRiskAnalysesMultiple,
          }
        },
        {
          path: ':confinedSpaceId/risk-analyses',
          name: 'confined-spaces-risk-analyses',
          components: {
            risk_analyses_index: ConfinedSpaceRiskAnalyses,
          }
        },
        {
          path: ':confinedSpaceId/risk-analyses-create',
          name: 'confined-spaces-risk-analyses-create',
          components: {
            risk_analyses_create_index: ConfinedSpaceRiskAnalysesForm,
          }
        },
        {
          path: 'action-plan',
          name: 'confined-spaces-action-plan',
          components: {
            action_plan_index: ConfinedSpaceActionPlanIndex,
          },
        },
        {
          path: 'action-plan/form/:step([123])?',
          name: 'confined-spaces-action-plan-form',
          components: {
            action_plan_form: ConfinedSpaceActionPlanForm,
          },
        },
      ],
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/work-front/:action?',
      components: {
        default: WorkFrontIndex,
      },
      children: [
        {
          path: '',
          name: 'work-front',
          components: {
            filter: WorkFrontFilter,
            table: WorkFrontTable,
          },
        },
        {
          path: 'create',
          name: 'work-front-create',
          components: {
            form: WorkFrontForm
          }
        },
        {
          path: 'edit/:id(\\d+)',
          name: 'work-front-edit',
          components: {
            form: WorkFrontForm,
          },
        },
      ],
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/users/:action?',
      components: {
        default: UserIndex,
      },
      children: [
        {
          path: '',
          components: {
            filter: UserFilter,
            table: UserTable,
          },
        },
        {
          path: 'create',
          components: {
            filter: UserFilter,
            form: UserForm,
          },
        },
        {
          path: 'edit/:id(\\d+)',
          components: {
            filter: UserFilter,
            form: UserForm,
          },
        },
      ],
      meta: {
        requiresAuth: true,
        controlPanel: 'admin',
        admin: true,
      },
    },
    {
      path: '/preliminary-risk-analyses/:machineId/risk-analyses',
      name: 'risk-analyses',
      component: RiskAnalysisIndex,
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/methodology',
      name: 'methodology',
      component: Methodology,
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/ART',
      name: 'ART',
      component: ART,
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/preliminary-risk-analyses/:machineId/risk-analyses/checklist',
      name: 'risk-analysis-checklist',
      component: RiskAnalysisChecklistForm,
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/preliminary-risk-analyses/:machineId/risk-analyses/create',
      name: 'risk-analysis-create',
      component: RiskAnalysisForm,
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/preliminary-risk-analyses/print-machines-and-ar',
      name: 'risk-analysis-print-machines-and-ar',
      component: RiskAnalysisPrintMachinesAndAr,
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
        path: '/preliminary-risk-analyses/machines-print',
        name: 'risk-analysis-print-machines',
        component: RiskAnalysisPrintMachines,
        meta: {
            requiresAuth: true,
            controlPanel: 'operational',
        },
    },
    {
      path: '/preliminary-risk-analyses',
      name: 'preliminary-risk-analyses',
      component: PreliminaryRiskAnalysisIndex,
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/preliminary-risk-analyses/print_ra',
      name: 'print-ra',
      component: PrintRAindex,
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/noncompliance-models/:action?',
      components: {
        default: NonComplianceModelIndex,
      },
      children: [
        {
          path: '',
          components: {
            filter: NonComplianceModelFilter,
            table: NonComplianceModelTable,
          },
        },
        {
          path: 'create',
          components: {
            filter: NonComplianceModelFilter,
            form: NonComplianceModelForm,
          },
        },
        {
          path: 'edit/:id(\\d+)',
          components: {
            filter: NonComplianceModelFilter,
            form: NonComplianceModelForm,
          },
        },
      ],
      meta: {
        requiresAuth: true,
        controlPanel: 'admin',
        admin: true,
      },
    },
    {
      path: '/users',
      name: 'users',
      components: {
        default: UserIndex,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'admin',
      },
    },
    {
      path: '/user-create',
      name: 'user-create',
      components: {
        default: UserForm,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'admin',
      },
    },
    {
      path: '/user-edit/:id',
      name: 'user-edit',
      components: {
        default: UserForm,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'admin',
      },
    },
    {
      path: '/action-plan',
      name: 'action-plan',
      components: {
        default: ActionPlanIndex,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/action-plan/graphics',
      name: 'action-plan-print-graphics',
      components: {
        default: ActionPlanPrintGraphics,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/action-plan/situations',
      name: 'action-plan-print-situations',
      components: {
        default: ActionPlanPrintSituations,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/action-plan/:riskAnalysisDescriptionId/form-item-detailing',
      name: 'action-plan-print-detailing',
      components: {
        default: ActionPlanFormItemDetailing,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/machines/create',
      name: 'machines-create',
      components: {
        default: MachineForm,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/machines/destroy/:id',
      name: 'machines-destroy',
      components: {
        table: MachineTable,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/action-plan/form/:step([123])?',
      name: 'action-plan-form',
      components: {
        default: ActionPlanForm,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/action-plan/:riskAnalysisDescriptionId/signaling-form',
      name: 'action-plan-signaling-form',
      components: {
        default: SingnalingForm,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/action-plan/:riskAnalysisDescriptionId/boilermaking-form',
      name: 'action-plan-boilermaking-form',
      components: {
        default: BoilermakingForm,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/action-plan/:riskAnalysisDescriptionId/construction-form',
      name: 'action-plan-construction-form',
      components: {
        default: ConstructionForm,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/action-plan/:riskAnalysisDescriptionId/security-devices-form',
      name: 'action-plan-security-devices-form',
      components: {
        default: SecurityDevicesForm,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/action-plan/:riskAnalysisDescriptionId/electric-form',
      name: 'action-plan-electric-form',
      components: {
        default: ElectricForm,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/action-plan/:riskAnalysisDescriptionId/painting-form',
      name: 'action-plan-painting-form',
      components: {
        default: PaintingForm,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
    {
      path: '/action-plan/:riskAnalysisDescriptionId/difficulties-form',
      name: 'action-plan-difficulties-form',
      components: {
        default: DifficultiesForm,
      },
      meta: {
        requiresAuth: true,
        controlPanel: 'operational',
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  const authenticated_user = store.getters['authenticated_user']
  const requires_auth = to.matched.some((record) => record.meta.requiresAuth)
  const control_panel = to.matched[0].meta.controlPanel
  const requires_admin = to.matched.some((record) => record.meta.admin)

  store.dispatch('selectControlPanel', control_panel)
  store.dispatch('setAuthenticatedUser').then(() => {
    if (requires_auth && authenticated_user == null) {
      if (store.getters['authenticated_user'] == null) {
        next({ name: 'login' })
      } else {
        next()
      }
    } else if (requires_admin && authenticated_user.user_profile.name !== 'Admin') {
      if (store.getters['authenticated_user'].user_profile.name !== 'Admin') {
        next({ name: 'index' })
      }
      next({ name: 'index' })
    } else {
      next()
    }
  }).catch(() => {
    // API indisponível ou erro de rede — redirecionar para login
    if (requires_auth) {
      next({ name: 'login' })
    } else {
      next()
    }
  })
})

export default router
